import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { TenderActionTypes } from "./Tender.type";

export function* fetchAllTenders(action: any): any {
  try {
    const params = new URLSearchParams();
    if (action.payload && typeof action.payload === "object") {
      Object.keys(action.payload).forEach((key) => {
        const val = action.payload[key];
        if (val !== undefined && val !== null && val !== "undefined" && val !== "") {
          params.append(key, val);
        }
      });
    }
    const queryString = params.toString() ? `?${params.toString()}` : "";
    const response = yield axios.get(`${API_BASE_URI}/tender${queryString}`);
    yield put({
      type: TenderActionTypes.FETCH_ALL_TENDER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: TenderActionTypes.FETCH_ALL_TENDER_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneTenders(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/tender/${action.payload}`
    );
    yield put({
      type: TenderActionTypes.FETCH_ONE_TENDER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: TenderActionTypes.FETCH_ONE_TENDER_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllTenders() {
  yield takeLatest(TenderActionTypes.FETCH_ALL_TENDER, fetchAllTenders);
}

export function* watcherFetchOneTenders() {
  yield takeLatest(TenderActionTypes.FETCH_ONE_TENDER, fetchOneTenders);
}
